<template>
    <div>
        <div class="mgv2__dropdown-button" @click="categoryDropDownIsOpen = !categoryDropDownIsOpen"  
            :class="categoryDropDownIsOpen ? 'mgv2__dropdown--is-open' : 'mgv2__dropdown--is-closed'">
            <span class="mgv2__dropdown-label">{{ selectedFirstLevelCategory }}</span>
            <span class="mgv2__dropdown-arrow"></span>
        </div>
        <ul v-if="!computedOnlyOneCategory" class="mgv2__dropdown-choices" :class="categoryDropDownIsOpen ? 'mgv2__dropdown-choices--is-open' : 'mgv2__dropdown-choices--is-closed'">
            <li v-for="(cat, index) in computedFirstLevelTaxonomy">
                <a href="#"
                    :key="index"
                    @click.prevent="selectMainCategory(cat)" 
                    :class="{ 'mgv2__dropdown-choices--selected': cat.selectedLink }"
                >{{ cat.name }}</a></li>
        </ul>

        <div class="mgv2__description" v-if="description.length > 0">
            <p>{{ description }}</p>
        </div>

        <div v-if="secondLevelTaxonomy.length > 0" class="mgv2__chips">
            <Chip v-for="chip in secondLevelTaxonomy" :key="chip.name" :label="chip.name" :checked="chip.checked" :parent="chip.parent" @toggle="toggleChip" />
        </div>

        <div class="mgv2__items">
            <section 
                class="mgv2__item"
                v-for="(post, index) in filteredPosts.slice(0, computedPageRange)"
                :key="index"
            >
                <picture>
                    <source :srcset="post.srcset" :sizes="post.sizes" />
                    <img
                        loading="lazy"
                        :src="post.src"
                        :width="post.width"
                        :height="post.height"
                        :sizes="post.sizes"
                        :alt="post.alt"
                    />
                </picture>
                <div class="mgv2__item-content">
                    <div>
                        {{ getCategoryInformation(post.terms, 0) }} <span> | </span> <span>{{ getCategoryInformation(post.terms, 1) }}</span>
                    </div>
                    <div class="mgv2__separator"></div>
                    <h3>{{ post.title }}</h3>
                </div>
                <a
                    aria-label=""
                    :href="post.link"
                >
                </a>
            </section>
        </div>
        <div v-if="computedShowMore" class="mgv2__load-more">
            <a href="#" @click.stop="loadMore" class="btn--quinary">
                {{ loadMoreText }}
            </a>
        </div>
    </div> 
</template>

<script lang="javascript">
import lazyloader from "@pernod-ricard-global-cms/cbllazyloader";
import { sequentialFade } from "@pernod-ricard-global-cms/jsanimations";
import jsAssets from "Assets/js/modules/jsAssets";
import Chip from './masterGridV2Chip.vue'; 

export default {
    components: {
        Chip
    },
    name: "masterGridV2",
    data() {
        return {
            allPosts: [],
            taxonomies: [],
            preview: false,
            allText: "",
            allDescription: "",
            loadMoreText: "",
            locale: "",
            defaultItemsDesktop: 3,
            defaultItemsMobile: 3,
            description: "",
            // other variables
            categoryDropDownIsOpen: false,
            selectedFirstLevelCategory: '',
            secondLevelTaxonomy: [],
            thumbnailOverlay: true,
            showButton: false,
            postsPerPage: 3,
            dropDownActive: false,
            page: 0,
            filteredPosts: [],
        };
    },
    beforeMount() {
        this.allPosts = JSON.parse(this.$parent.posts);
		this.taxonomies = JSON.parse(this.$parent.taxonomies);
        this.preview = !!this.$parent.ispreview;
        this.allText = this.$parent.alltext;
        this.allDescription = this.$parent.alldescription;
        this.loadMoreText = this.$parent.loadmoretext;
        this.locale = this.$parent.locale;
        this.defaultItemsDesktop = parseInt(this.$parent.defaultitemsdesktop);
        this.defaultItemsMobile = parseInt(this.$parent.defaultitemsmobile);
        this.selectedFirstLevelCategory = this.allText;
        this.description = this.allDescription; 

        this.filteredPosts = this.allPosts;
    },
    mounted() {
        this.resetSecondLevelCategories();

        // check if there is only one Main Category in the list
        if (this.computedOnlyOneCategory) {
            this.selectMainCategory(this.computedFirstLevelTaxonomy[1]);
        }
    },
    methods: {
		loadMore() {
			this.page += 1;
			this.$nextTick(function () {
				const elementsToFadeIn = document.querySelectorAll(
					".mgv2__post"
				);
			});
		},
        selectLink(term_id) {
            this.computedFirstLevelTaxonomy.forEach((link) => {
                link.selectedLink = link.term_id === term_id;
            });
        },
        selectMainCategory(cat) {
            if (typeof cat !== 'undefined') {
                this.filterItemsByCategory(cat.term_id);
                this.displaySecondaryCategories(cat.term_id);
                this.setFirstLevelCategorySelected(cat.name);
                this.resetSecondLevelCategories();
                this.displayCategoryDescription(cat.description);
                this.selectLink(cat.term_id);
                this.categoryDropDownIsOpen = !this.categoryDropDownIsOpen;
            }
            return;
        },
        displayCategoryDescription(description) {
            this.description = description;
        },
        filterItemsByCategory(parentId) {
            if (parentId == 0) {
                this.filteredPosts = this.allPosts;
                return;
            }
            this.filteredPosts = this.allPosts.filter(post => {
                if (post.terms !== null) {
                    return post.terms.find(obj => obj.term_id == parentId);
                }
            })
            return;
        },
        displaySecondaryCategories(parentId) {
            this.secondLevelTaxonomy = [];
            if (parentId == 0) {
                return
            }
            if(typeof parentId !== 'undefined') {
                this.secondLevelTaxonomy = this.taxonomies.filter(category => {
                    return category.parent == parentId
                }).sort(function(a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }
                    return 0;
                });
            }
            return;
        },
        resetSecondLevelCategories() {
            let categories = this.secondLevelTaxonomy;
            this.secondLevelTaxonomy = [];
            categories.forEach(item => {
                item.checked = false;
                this.secondLevelTaxonomy.push(item);
            });
        },
        setFirstLevelCategorySelected(name) {
            this.selectedFirstLevelCategory = name;
        },
        getCategoryInformation(terms, parent) {
            let obj = {};
            if (terms == null || typeof terms == 'undefined') {
                return;
            }
            if (parent === 0){
                obj = terms.find(o => o.parent === parent);
            } else {
                obj = terms.find(o => o.parent !== 0);
            }
            if (typeof obj !== 'undefined' && 'name' in obj) {
                return obj.name;
            } 
            return;
        },
        toggleChip(label, checked, parent) {
            if(label) {
                // reset all catgories
                this.resetSecondLevelCategories();
                if (checked) {
                    this.filterItemsByCategory(parent);
                    return;
                };

                let updatedObject = this.secondLevelTaxonomy.find(c => c.name === label);
                // Find the index of the object to replace based on the key
                let index = this.secondLevelTaxonomy.findIndex(obj => obj.name === label);
                // Replace the object at the found index using push()
                if (index !== -1) {
                    updatedObject.checked = !updatedObject.checked;
                    this.secondLevelTaxonomy.push(updatedObject);
                    this.secondLevelTaxonomy.splice(index, 1);
                    // orders again the categories
                    this.secondLevelTaxonomy.sort(function(a, b) {
                        var nameA = a.name.toUpperCase();
                        var nameB = b.name.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    });
                }
                this.filterItemsByCategory(this.secondLevelTaxonomy[index].term_id);
            }

            return;
        }
    },
    computed: {
		computedPageRange() {
            const items = this.isMobile ? this.defaultItemsMobile : this.defaultItemsDesktop;
			return this.page * this.postsPerPage + items;
		},
		computedShowMore() {
			return this.computedPageRange < this.filteredPosts.length
				? (this.showButton = true)
				: (this.showButton = false);
		},
        isMobile() {
            return (screen.width < 1200);
        },
        computedFirstLevelTaxonomy() {
            let filteredCategories = [];
            this.taxonomies.push({
                term_id: 0,
                name: this.allText,
                description: this.allDescription,
                selectedLink: false,
                parent: 0,
                term_order: "-1",
                slug: 'all'
            })
            filteredCategories = this.taxonomies.filter(category => {
                return category.parent == 0
            }).sort((a, b) => a.term_order - b.term_order);
            return filteredCategories;
        },
        computedOnlyOneCategory() {
            // taxonimies contains already the allText term, so by default
            // there is at least one category
            return (this.computedFirstLevelTaxonomy.length == 2);
        }
    }
};
</script>
